import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";

import { SUPPORTED_LANGUAGES } from "@/common/constants/languages";

interface LanguageMismatchDialogProps {
  open: boolean;
  urls: string[];
  lang: string;
  onConfirmRewrite: () => void;
  onSendAsIs: () => void;
  onDismiss: () => void;
}

export default function LanguageMismatchDialog({
  open,
  urls,
  lang,
  onConfirmRewrite,
  onSendAsIs,
  onDismiss,
}: LanguageMismatchDialogProps) {
  const languageName =
    SUPPORTED_LANGUAGES.find((l) => l.code === lang)?.name ?? lang;
  const prompt =
    urls.length === 1
      ? `This link will open in English. Send in ${languageName} instead?`
      : `These links will open in English. Send in ${languageName} instead?`;

  return (
    <Dialog
      open={open}
      onClose={onDismiss}
      maxWidth="sm"
      fullWidth
      aria-labelledby="lang-mismatch-dialog-title"
      aria-describedby="lang-mismatch-dialog-description"
    >
      <DialogTitle id="lang-mismatch-dialog-title">
        Update link language?
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="lang-mismatch-dialog-description">
          {prompt}
        </DialogContentText>
        <List dense>
          {urls.map((url) => (
            <ListItem key={url} disableGutters>
              <ListItemText
                primary={url}
                slotProps={{
                  primary: {
                    variant: "body2",
                    sx: { wordBreak: "break-all" },
                  },
                }}
              />
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onSendAsIs}>Send as-is</Button>
        <Button onClick={onConfirmRewrite} variant="contained">
          Update link & send
        </Button>
      </DialogActions>
    </Dialog>
  );
}
